import React from 'react';
import UnityWebViewer from '../components/UnityWebViewer';


const HomePage = () => {

   const userData = {
      name: "GUEST",
      id: "USER123",
      organizationId: "",
      subscriptionStatus: "free"
    }

return(
  <div className="App">
    <UnityWebViewer
      experienceId="9225a575-dd6c-4774-8ce0-e1a9a778ce11"
      userData={userData}
      showPlatformSignupCta
    />
  </div>
);
}


export default HomePage;
